var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGyAsy6IconsCmykGripWhtPrintAw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170.1 170.1",
    style: {
      enableBackground: "new 0 0 170.1 170.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BLUE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85,158.7c-40.6,0-73.7-33.1-73.7-73.7S44.4,11.3,85,11.3s73.7,33.1,73.7,73.7S125.7,158.7,85,158.7z M85,22.4 c-34.5,0-62.6,28.1-62.6,62.6s28.1,62.6,62.6,62.6s62.6-28.1,62.6-62.6C147.7,50.5,119.6,22.4,85,22.4z M61.7,70.8 c-4.9,0-8.9,3.9-8.9,8.6c0,4.8,4,8.6,8.9,8.6h45.4c5.5,0,10-4.4,10-9.8s-4.5-9.8-10-9.8c-0.4,0-0.8,0-1.2,0.1 c0.1-0.7,0.2-1.4,0.2-2.2c0-7-5.9-12.8-13.1-12.8c-5.8,0-10.6,3.6-12.4,8.6c-1.6-0.9-3.4-1.5-5.4-1.5c-5.7,0-10.4,4.5-10.4,10.1 c0,0.1,0,0.3,0,0.4C63.9,71,62.8,70.8,61.7,70.8 M83.1,94.4c-2.9,1.4-3.2,5.4-0.4,7.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0 c2.8,1.6,6.3-0.4,6.3-3.5v-6.6L83.1,94.4 M99.9,94.4c-2.9,1.4-3.2,5.4-0.4,7.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0 c2.8,1.6,6.3-0.4,6.3-3.5v-6.6L99.9,94.4 M66.4,94.4c-2.9,1.4-3.2,5.4-0.4,7.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0 c2.8,1.6,6.3-0.4,6.3-3.5v-6.6L66.4,94.4 M91.5,108.6c-2.9,1.4-3.2,5.4-0.4,7.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0 c2.8,1.6,6.3-0.4,6.3-3.5v-6.6L91.5,108.6 M74.8,108.6c-2.9,1.4-3.2,5.4-0.4,7.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0 c2.8,1.6,6.3-0.4,6.3-3.5v-6.6L74.8,108.6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGyAsy6IconsCmykGripWhtPrintAw);
export default __webpack_public_path__ + "static/media/GY_ASY6_ICONS_CMYK_GRIP_WHT_PRINT_AW.46713a13eb22c9d05f91379a4a3753f1.svg";
export { ForwardRef as ReactComponent };